import PropTypes from 'prop-types';
/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export const asPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]);

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export const stylePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]);

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 * Type used for render props
 *
 * ```typescript
 * type MyComponentProps = StylableComponent<HTMLDivElement> & {
 * renderBody?: (props: StylableRenderPropType) => ReactElement;
 * }
 * ```
 */
//# sourceMappingURL=styledComponent.js.map